import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage/session';
import customHardSet from './custom-hard-set';
var defaultOptions = {
  stateReconciler: customHardSet,
  timeout: null
};

/**
 *
 */
export default function persistToSessionStorage(key, reducer) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultOptions,
    _ref$stateReconciler = _ref.stateReconciler,
    stateReconciler = _ref$stateReconciler === void 0 ? customHardSet : _ref$stateReconciler,
    timeout = _ref.timeout,
    rest = _objectWithoutProperties(_ref, ["stateReconciler", "timeout"]);
  return persistReducer(_objectSpread({
    key: key,
    storage: storage,
    stateReconciler: stateReconciler,
    timeout: timeout
  }, rest), reducer);
}